/**
 * Routines feature identity (design 5.2): the single cross-side definition
 * of the feature's name and the canonical entitlement key it carries
 * (scheduled AI routines: CRUD, run history, templates, prompt tooling).
 * Imported by worker/src/features/routines/module.ts and
 * frontend/src/features/routines/module.ts.
 */

import { defineIdentity } from '../featureModule'

export const identity = defineIdentity({
  name: 'routines',
  entitlements: ['routines'],
})
